import { useState } from "react";
import CustomSnackbar from "../../../../../../components/ui/CustomSnackbar/customSnackbar";
import parentStyles from "../../../Details/details.module.css";
import { Button } from '@mui/material';
import styles from './UpdateCreditAddonModal.module.css'
import CustomModal from "../../../../../../components/ui/CustomModal/customModal";
import ApiService from "../../../../../../components/apiService/ApiService";

const creditAddonTypeOptions = {"per_org": "Per org", "per_user": "Per plan license"};

const UpdateCreditAddonModal = (props) => {
    const {setVisible, visible, credit_addon, credit_addon_type, accountId} = props;
    const [creditAddon, setCreditAddon] = useState(credit_addon);
    const [response, setResponse] = useState({});
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [creditAddonType, setCreditAddonType] = useState(credit_addon_type);
    const [isDisabled, setIsDisabled] = useState(true);

    const handleFeedback = (response) => {
      console.log(response);
      if (response?.success) {
        setResponse(response);
      } else {
        setResponse({
          message: response.message,
          success: false,
        });
      }
      setShowSnackbar(true);
    };

    const handleSaveChanges = () => {
        if (isNaN(creditAddon) || creditAddon < 0){
            setResponse({success: false, message: "Invalid value for credit addon amount"})
            setShowSnackbar(true);
            return;
      }
        let payload = {
            credit_addon: creditAddon,
            credit_addon_type: creditAddonType
        }
        ApiService.patch(
        `/api/v1/dashboard/update-subscription/${accountId}/`,
        payload,
        )
        .then((res) => {
            setShowSnackbar(true);
            setResponse({
            message: "Subscription will be updated shortly",
            success: true,
            });
        })
        .catch((error) => {
            handleFeedback(error.response);
        })
        .finally(() => {
            setVisible(false);
        })
  };

    return (
      <>
        <CustomModal
            heading="Update Credit Addon"
            visible={visible}
            closeModal={() => setVisible(false)}
            bodyStyles={{
              width: "380px",
              padding: "2em",
            }}
            body={
              <div>
                <div className={styles.container}>
                    <form className={styles.form}>
                        <div className={parentStyles.property}>
                            <label>Credit amount</label>
                            <input
                              type="text"
                              name="credit_addon"
                              value={creditAddon}
                              onChange={(e) => {
                                setCreditAddon(e.target.value);
                                setIsDisabled(false);
                              }}
                            />
                        </div>
                        <div className={parentStyles.property}>
                            <label>Credit allocation type</label>
                            <select
                              value={creditAddonType}
                              onChange={(e) => {
                                setIsDisabled(false);
                                setCreditAddonType(e.target.value);
                              }}
                            >
                              {Object.entries(creditAddonTypeOptions).map(([val, label]) => {
                                return <option value={val} key={val}>{label}</option>;
                              })}
                            </select>
                        </div>
                    </form>
                <p className={styles.info}>(Changes made to the credit amount or allocation type here, will affect the credit balance of the org, and will be updated in zoho billing immediately.)</p>
                <div className={styles.footerContainer}>
                   <Button
                        sx={{
                          margin: "35px 5px 0",
                        }}
                        className={parentStyles.button}
                        variant="outlined"
                        color="success"
                        onClick={() => setVisible(false)}
                      >
                        Cancel
                      </Button>
                    <Button
                        sx={{
                          margin: "35px 5px 0",
                          bgcolor: "#36cb64",
                          color: "white",
                          ":hover": {
                            bgcolor: "#28994B",
                          },
                        }}
                        className={parentStyles.button}
                        variant="outlined"
                        onClick={handleSaveChanges}
                        disabled={isDisabled}
                      >
                        Update
                      </Button>
                </div>
               </div>
              </div>
            }
        />
        {showSnackbar && (
          <CustomSnackbar
            setShowSnackbar={setShowSnackbar}
            message={response.message}
            type={response.success ? "success" : "error"}
            onClose={() => setShowSnackbar(false)}
          />
        )}
    </>)
}

export default UpdateCreditAddonModal